<template>
  <GenericStep v-bind="$attrs">
    <div
      v-for="email of peParty.emails"
      :key="email.id"
      class="mb-12"
    >
      <EmailCard
        class="mb-4"
        :item="email"
      />
    </div>

    <SectionAdderLine
      section="Email"
      :has-new-section="peEmailCardHasNewSection"
      @on-add="peEmailCardAddSection"
    />

    <div
      v-for="phone of peParty.phones"
      :key="phone.id"
      class="mb-12"
    >
      <PhoneCard
        class="mb-4"
        :item="phone"
      />
    </div>

    <SectionAdderLine
      section="Phone"
      :has-new-section="pePhoneCardHasNewSection"
      @on-add="pePhoneCardAddSection"
    />
  </GenericStep>
</template>

<script>
import { cloneDeep, isEqual } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import EmailCard from '@/components/Party/PartyEdit/SectionCards/PersonalDataCards/EmailCard.vue'
import GenericStep from '@/components/Party/QuickInterview/GenericStep.vue'
import PhoneCard from '@/components/Party/PartyEdit/SectionCards/PersonalDataCards/PhoneCard.vue'
import SectionAdderLine from '@/components/Party/PartyEdit/SectionTools/SectionAdderLine.vue'

export default {
  name: 'ContactsStep',

  components: {
    EmailCard,
    GenericStep,
    PhoneCard,
    SectionAdderLine,
  },

  inheritAttrs: false,

  data () {
    return {
      hasChanged: false,
      originalData: null,
    }
  },

  computed: {
    relevantFields () {
      return {
        emails: this.peParty.emails,
        phones: this.peParty.phones,
      }
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peEmailCardHasNewSection',
      'peParty',
      'pePhoneCardHasNewSection',
    ]),
  },

  watch: {
    relevantFields (value) {
      if (!this.hasChanged && !isEqual(value, this.originalData)) {
        this.hasChanged = true
        this.$emit('changed', true)
      }
    },
  },

  created () {
    this.originalData = cloneDeep(this.relevantFields)
  },

  methods: {
    ...mapActions(PARTY_NAMESPACE, [
      'peEmailCardAddSection',
      'pePhoneCardAddSection',
    ]),
  },
}
</script>
